import { fetchAndParse } from '../lib/utils';
import { ClientConfig } from '../types/ClientConfig';
import { Employee } from '../types/Employee';
import { BaseClient, Endpoints, getHeaders } from './BaseClient';

export const UsersClient = (config: ClientConfig) => {
    const { accessToken } = config;
    const headers = getHeaders(accessToken);

    const getUsers = (): Promise<Employee[]> => {
        const apiUrl = `${BaseClient({ useAdminRoute: true }).getApiUrl(Endpoints.USERS)}`;

        return fetchAndParse<Employee[]>(apiUrl, { headers });
    };

    const getUser = (userId: string): Promise<Employee> => {
        const apiUrl = `${BaseClient({ useAdminRoute: true }).getApiUrl(Endpoints.USERS)}/${userId}`;

        return fetchAndParse<Employee>(apiUrl, { headers });
    };

    const setFuelConsumptionPercentageDeviation = (userId: string, deviation: number): Promise<Response> => {
        const apiUrl = `${BaseClient({ useAdminRoute: true }).getApiUrl(Endpoints.USERS)}`;

        return fetch(apiUrl, {
            headers,
            method: 'POST',
            body: JSON.stringify({ deviationFromFuelConsumption: deviation, id: userId }),
        });
    };

    const validateToken = (): Promise<string> => {
        const apiUrl = `${BaseClient({}).getApiUrl(Endpoints.USERS)}/validatetoken`;

        return fetchAndParse<string>(apiUrl, { headers });
    };

    return {
        getUsers,
        getUser,
        validateToken,
        setFuelConsumptionPercentageDeviation,
    };
};
